const MAP = {
  // Drops
  READY: { label: "READY NOW", cls: "bg-yaza-accent text-black border border-transparent" },
  SOON: { label: "DROPPING SOON", cls: "bg-transparent text-yaza-accent border-2 border-yaza-accent" },
  SOLD_OUT: { label: "SOLD OUT", cls: "bg-transparent text-yaza-grey border border-yaza-grey" },
  // Strains availability
  AVAILABLE: { label: "AVAILABLE", cls: "bg-yaza-accent text-black border border-transparent" },
  LIMITED: { label: "LIMITED", cls: "bg-transparent text-yaza-accent border-2 border-yaza-accent" },
  DROPPING_SOON: { label: "DROPPING SOON", cls: "bg-transparent text-yaza-accent border-2 border-yaza-accent" },
};

export default function StatusBadge({ status, className = "" }) {
  const s = MAP[status] || { label: status, cls: "text-white border border-white/30" };
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-block px-3 py-1 font-mono text-[10px] font-bold uppercase tracking-widest ${s.cls} ${className}`}
    >
      {s.label}
    </span>
  );
}
